import { z } from 'zod';

const normalizeCommodityCode = (value) => value.replace(/\s/g, '');

export const addCommodityCodeSchema = z.object({
  commodityCode: z
    .string()
    .refine((value) => /^[\d\s]*$/.test(value), 'Please enter numbers only.')
    .refine((value) => normalizeCommodityCode(value).length > 0, 'Commodity code is required')
    .refine((value) => normalizeCommodityCode(value).length === 10, 'Commodity code must be exactly 10 digits'),
});

export const getNormalizedCommodityCode = normalizeCommodityCode;
